import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import { CoverageLeaflet } from "@/components/CoverageLeaflet";
import { MapPin } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function PublicCoverage() {
  const { token } = useParams();
  const [data, setData] = useState(null);
  const [err, setErr] = useState(false);

  useEffect(() => { axios.get(`${API}/public/coverage/${token}`).then((r) => setData(r.data)).catch(() => setErr(true)); }, [token]);

  if (err) return <div className="min-h-screen bg-black text-zinc-400 flex items-center justify-center font-mono">Coverage map not available.</div>;

  return (
    <div className="min-h-screen bg-black text-white">
      <div className="max-w-5xl mx-auto px-4 py-10">
        <div className="font-mono text-xs uppercase tracking-widest text-[#FF5722] mb-1">Service Coverage</div>
        <h1 className="font-head font-black uppercase text-3xl sm:text-4xl tracking-tight">{data?.company || "Swift Signings & Services"}</h1>
        <p className="text-zinc-500 text-sm mt-1 font-mono">Areas we currently serve — colored by state.</p>
        <div className="mt-6 border-2 border-zinc-800 overflow-hidden" data-testid="public-coverage-card">
          {data ? <CoverageLeaflet points={data.points} states={data.states} height={520} showNames={false} />
            : <div className="h-[520px] flex items-center justify-center text-zinc-600 font-mono"><MapPin className="mr-2" size={16} /> Loading…</div>}
        </div>
      </div>
    </div>
  );
}
